import React, { useMemo } from 'react'
import { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'
import { ResourceList } from '@/Core/UI/CrudResource/ResourceList'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { RequestResource } from '../Resources/RequestResource'
import { FaClipboardList } from 'react-icons/fa'

const RequestPage: React.FC = () => {
    const listContext = useMemo(() => createCrudResourceContext({
        contextType: 'list',
        registryKey: 'Request.list',
        resource: RequestResource,
    } as any), [])

    return <ResourceList crudContext={listContext} />
}

export default RequestPage

export const pageConfig: IPageConfig = {
    key: 'Request',
    title: 'Заявки',
    icon: <FaClipboardList />,
}
